import * as z from 'zod';
import { BillingProfile, BillingProfileFormValues } from '../services/subscription-service';

export const emptyBillingForm: BillingProfileFormValues = {
  legalName: '',
  displayName: '',
  billingContactName: '',
  billingContactEmail: '',
  line1: '',
  line2: '',
  city: '',
  region: '',
  postalCode: '',
  countryCode: '',
  taxRegistrationId: '',
};

export const createBillingSchema = (t: (key: string, defaultValue?: string) => string) =>
  z.object({
    legalName: z.string().min(1, t('LEGAL_NAME_REQUIRED', 'Legal name is required')),
    displayName: z.string().optional(),
    billingContactName: z.string().min(1, t('NAME_REQUIRED')),
    billingContactEmail: z.string().min(1, t('EMAIL_REQUIRED')).email(t('VALID_EMAIL_REQUIRED')),
    line1: z.string().optional(),
    line2: z.string().optional(),
    city: z.string().optional(),
    region: z.string().optional(),
    postalCode: z.string().optional(),
    countryCode: z
      .string()
      .optional()
      .refine((value) => !value || /^[A-Za-z]{2}$/.test(value), t('COUNTRY_CODE_INVALID', 'Two letters, ISO 3166-1.')),
    taxRegistrationId: z.string().optional(),
  });

/** The saved profile as form values, with the signed-in person as the contact when none is saved. */
export const billingFormFromProfile = (
  profile: BillingProfile | null | undefined,
  contact: { name: string; email: string }
): BillingProfileFormValues => ({
  legalName: profile?.legalName ?? '',
  displayName: profile?.displayName ?? '',
  billingContactName: profile?.billingContactName || contact.name,
  billingContactEmail: profile?.billingContactEmail || contact.email,
  line1: profile?.address?.line1 ?? '',
  line2: profile?.address?.line2 ?? '',
  city: profile?.address?.city ?? '',
  region: profile?.address?.region ?? '',
  postalCode: profile?.address?.postalCode ?? '',
  countryCode: profile?.address?.countryCode ?? '',
  taxRegistrationId: profile?.taxRegistrationId ?? '',
});
